import { formatDateTime, DISPLAY_EMPTY } from '@/shared/lib/dateFormat';

/** 배치 job API 시각 필드: 한 줄 표기 */
export const formatBatchJobDateTime = (value: unknown): string => {
  if (value == null || value === '') return '—';
  const formatted = formatDateTime(String(value));
  return formatted === DISPLAY_EMPTY ? '—' : formatted;
};
